/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { LocationTag } from './LocationTag'
import { LocationTagFromJSON, LocationTagFromJSONTyped, LocationTagToJSON } from './LocationTag'

/**
 *
 * @export
 * @interface PaginatedLocationTagListAdmin
 */
export interface PaginatedLocationTagListAdmin {
  /**
   *
   * @type {Array<LocationTag>}
   * @memberof PaginatedLocationTagListAdmin
   */
  results: Array<LocationTag>
  /**
   *
   * @type {number}
   * @memberof PaginatedLocationTagListAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedLocationTagListAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedLocationTagListAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedLocationTagListAdmin interface.
 */
export function instanceOfPaginatedLocationTagListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedLocationTagListAdminFromJSON(json: any): PaginatedLocationTagListAdmin {
  return PaginatedLocationTagListAdminFromJSONTyped(json, false)
}

export function PaginatedLocationTagListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedLocationTagListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(LocationTagFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedLocationTagListAdminToJSON(
  value?: PaginatedLocationTagListAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(LocationTagToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
